/*
 * In this file, all kinds of initializations that vary from project to project are performed.
 */

// utils
import { TweenLite, Power1 } from 'gsap/TweenMax';
import 'EasePack';
import 'ScrollToPlugin';
import '@/scripts/utils/resize-iframe';
import '@/scripts/utils/table-responsive';
import objectFitImages from 'object-fit-images';
import objectFitVideos from 'object-fit-videos';
// import isMobile from '@/scripts/utils/detect-mobile';
// import isSafari from '@/scripts/utils/detect-safari';
import toArray from '@/scripts/utils/get-elements-array';
import initHeaderNav from '@/scripts/elements/header-nav';
import initGoogleMaps from '@/scripts/utils/initGoogleMaps';
import leadZero from '@/scripts/utils/lead-zero';
// import splitText from '@/scripts/lib/splitText';
// import resizeCover from '@/scripts/elements/cover';
// import breakpoints from '@/scripts/utils/_breakpoints';
import loadFonts from '@/scripts/utils/load-fonts';
import { startLoading, removePreloader } from '@/scripts/elements/preloader';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min';
import createEvent from '@/scripts/utils/create-event';

import VideoModal from '@/scripts/lib/VideoModal';

// import showWeather from '@/scripts/lib/weather';

// animation utils
// import selectors from '@/scripts/animation/animation-selectors';
// import SectionSecondaryAnimations from '@/scripts/animation/section-secondary';

// plugins
// import RollHoverBtn from '@/scripts/lib/RollHoverBtn';
import AnimatedListLine from '@/scripts/lib/AnimatedListLine';
// import SmoothScroll from '@/scripts/lib/SmoothScroll';
import Tabs from '@/scripts/lib/Tabs';
import FadeSlider from '@/scripts/lib/FadeSlider';
import initBookingMenu from '@/scripts/lib/bookingMenu';
import Dropdown from '@/scripts/lib/Dropdown';
import PageFilters from '@/scripts/lib/PageFilters';
import TabFilters from '@/scripts/lib/TabFilters';
import swiperSliderInit from '@/scripts/lib/swiper-slider';
// import PixiSlider from '@/scripts/lib/PixiSlider';

// ScrollMagic scenes
// import '@/scripts/utils/scrollmagic/scenes/header';
// import '@/scripts/utils/scrollmagic/scenes/reveal-images';
import '@/scripts/utils/scrollmagic/scenes/counter';
// Assets
import '@/fonts';
import '@/styles/main.scss';

// Set default easing
TweenLite.defaultEase = Power1.easeOut;

// Load fonts
loadFonts(['Quicksand:400,500:latin']);

const initBasics = () => {
  // set css transition-duration to get it in JS
  const duration = getComputedStyle(document.documentElement)['transition-duration'];
  document.documentElement.dataset.duration = parseFloat(duration);

  // object-fit polyfill
  objectFitImages(); // https://www.npmjs.com/package/object-fit-images
  objectFitVideos(); // https://www.npmjs.com/package/object-fit-videos

  // current year in footer-copyright
  $('.current-year').text((new Date()).getFullYear());

  // 1 -> 01, 11 -> 11
  $('[data-lead-zero="true"] span').text((i, text) => leadZero(text.trim()));

  // scroll-to button
  $('[data-role*="scroll-to"]').on('click', function () { // eslint-disable-line func-names
    const target = $(this).data('target');
    const $targetElement = $(`[data-role="${target}"]`);
    const offset = $targetElement.length && $targetElement.offset().top || 0;
    TweenLite.to(window, 1, { scrollTo: { y: offset, autoKill: false } });
  });

  // init dropdowns
  const dropdowns = toArray('[data-role*="dropdown-container"]');
  dropdowns.forEach(dropdown => new Dropdown({
    element: dropdown,
  }));

  // init page-filters form
  const pageFilters = new PageFilters({ // eslint-disable-line no-unused-vars
    element: document.querySelector('[data-role*="page-filters-container"]'),
  });

  // init tab-filters
  const tabFiltersGrid = toArray('[data-role*="grid-with-filters"]');
  tabFiltersGrid.forEach(el => new TabFilters({
    el,
    transitionDuration: 700,
    lineController: el.querySelector('[data-role*="animated-list-line"]'),
  }));

  // split chars
  /* const split = toArray('[data-split-text="true"]');
  split.forEach(el => splitText(el)); */

  // init loading button
  $('[data-role*="load-more-items"]:not([data-special-loading="true"])').on('click', function () { // eslint-disable-line func-names
    if (!this.dataset.num) {
      this.dataset.num = 0;
    }
    const { params } = this.dataset;
    const { type, url, data } = JSON.parse(params);
    const $container = $('[data-container="ajax-items-list"]');
    this.classList.add('loading');
    $.ajax({
      type,
      url,
      data: {
        ...data,
        num: this.dataset.num++, // eslint-disable-line no-plusplus
      },
      success: (result) => {
        if (result) {
          $container.append(result);
          imagesLoaded($container[0], () => {
            this.classList.remove('loading');
            window.dispatchEvent(createEvent('resize'));
          });
        } else {
          this.classList.add('is-disabled');
        }
      },
      error: () => {
        this.classList.add('is-disabled');
      },
    });
  });

  const googleMaps = toArray('[data-role*="google-maps-container"]');
  googleMaps.forEach(map => initGoogleMaps(map));
  // resizeCover();

  $('.editable table').responsiveTable();

  // showWeather(document.querySelector('[data-role="weather"]'));

  return true;
};

const initPlugins = () => {
  // menu init
  initHeaderNav({
    menuScrollContainer: '.menu__inner',
    menuContainer: '.menu__section_categories',
    menuWrapper: '.header__menu-wrapper',
    transitionDuration: 1000, // $menu-duration in scss file.
  });

  // list-line forwards active item
  const animatedLists = toArray('[data-role*="animated-list-line"]');
  animatedLists.forEach(list => new AnimatedListLine(list));

  // roll-hover buttons
  /* const rollButtons = toArray('[data-role*="roll-hover-btn"]');
  rollButtons.forEach(button => new RollHoverBtn(button)); */

  // tabs init
  const tabs = toArray('[data-role*="tab-list-container"]');
  tabs.forEach(el => new Tabs({
    mainContainer: el,
    lineController: el.querySelector('[data-role*="animated-list-line"]'),
  }));

  // fade slider init
  const fadeSliders = toArray('[data-role*="fade-slider-container"]');
  fadeSliders.forEach(el =>
    new FadeSlider({
      container: el,
      duration: 750,
      itemsToShow: 6,
    }));

  initBookingMenu();

  const videoModal = new VideoModal({ // eslint-disable-line no-unused-vars
    triggerElements: document.querySelectorAll('[data-role*="video-modal-trigger"]'),
  });

  return true;
};

const initSliders = () => {
  // homepage
  swiperSliderInit({
    selector: 'experiences',
    breakpoints: {
      1023: {
        slidesPerView: 2,
      },
      639: {
        slidesPerView: 1,
      },
    },
  });
  swiperSliderInit({
    slidesPerView: 2,
    spaceBetween: '14%',
    selector: 'offers',
    breakpoints: {
      1023: {
        slidesPerView: 2,
        spaceBetween: 60,
      },
      639: {
        slidesPerView: 1,
      },
    },
  });

  // page single-experience
  swiperSliderInit({
    slidesPerView: 2,
    spaceBetween: 30,
    selector: 'another-items',
    breakpoints: {
      639: {
        slidesPerView: 1,
      },
    },
  });


  // room-cards slider
  swiperSliderInit({
    slidesPerView: 3,
    spaceBetween: 30,
    selector: 'rooms',
    breakpoints: {
      1023: {
        slidesPerView: 2,
      },
      639: {
        slidesPerView: 1,
      },
    },
  });

  // single-room-card slider
  swiperSliderInit({
    slidesPerView: 1,
    spaceBetween: 0,
    selector: 'single-room',
    paginationType: 'bullets',
    pagination: true,
  });


  // mini-gallery (slider with progress)
  swiperSliderInit({
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 1000,
    pagination: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    selector: 'mini-gallery',
  });


  return true;
};


/* const initCoverAnimation = () => {
  const parentElement = document.querySelector('[data-role="pixi-slider"]');

  if (!parentElement) {
    return document.querySelector('header').classList.add('no-cover');
  }

  // Select all your images
  const spriteImages = toArray('[data-role="cover-slider-image"]');

  const spriteImagesSrc = spriteImages.map(image => image.src);

  // Initialise the Slideshow
  return new PixiSlider({

    parentElement,

    // pass the images you want as an array
    pixiSprites: spriteImagesSrc,

    // optionally start with a default animation
    autoPlay: true,

    // [x, y] controls the speed for your default animation
    autoPlaySpeed: [0, 0],

    // [x, y] controls the speed for your default animation
    slidePlaySpeed: [4, 6],

    // [x, y] controls the effect amount during transitions
    displaceScale: [20, 70],

    displaceScaleTo: [0, 0],

    applyDefaultStyles: false,

    // If you choose to not have a fullscreen slideshow, set the stage's width & height accordingly
    stageWidth: $(parentElement).width(),
    stageHeight: $(parentElement).height(),

    // add you navigation element. Should have a 'data-nav' attribute with a value of next/previous
    navElement: document.querySelectorAll('[data-role="cover-slider-nav"]'),

    // will fit the filter bounding box to the renderer
    displaceAutoFit: true,

    // add text to animate
    textes: document.querySelectorAll('[data-role="cover-slider-text"]'),
  });
}; */

/* const initScrollMagic = () => {
  // build scrollMagic
  const scenes =
    Array
      .from(document.querySelectorAll(selectors.sectionSecondary))
      .map(section => new SectionSecondaryAnimations(section));

  // this.sectionCoverMain = new sectionMainAnimations(document.querySelector(selectors.sectionPrimary));

  // this.scenes.push(this.sectionCoverMain);

  scenes.forEach((scene) => {
    scene.init();
  });

  return true;
}; */

// const initSmoothScroll = () => {
  // if (!isMobile() && !isSafari() && window.innerWidth > breakpoints.lg) {
  //   const smoothScroll = new SmoothScroll();
  //   smoothScroll.init();
  // }

  // return true;
// };


document.addEventListener('DOMContentLoaded', startLoading);
window.addEventListener('load', () => {
  Promise.resolve()
    .then(() => initBasics())
    .then(() => initSliders())
    .then(() => initPlugins())
    // .then(() => initCoverAnimation())
    // .then(() => initScrollMagic())
    // .then(() => initSmoothScroll())
    .then(() => removePreloader());
});



// WEBPACK FOOTER //
// ./scripts/common.js